<!-- TODO: Replace this html with the aproved table icon when that is finalized -->
<div class="tile-type-mat-icon-wrapper">
   <mat-icon>calendar_month</mat-icon>
</div>
